import React from 'react';
import styled from 'styled-components';
import { media } from 'theme';
import { Filter } from 'react-feather';
import { Text } from '@component-lib';
import get from 'lodash/get';
import { getCurrentCategory } from 'app/selectors/productSelector';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

const FilterSection = styled.div`
  display: flex;
  flex-direction: row;

  ${props => media.largeAndDown`
    margin-bottom: ${props.theme.spacing.xs};
    width: 100%;

    > *: nth-child(n+2) {
      margin-left: ${props.theme.spacing.xs};
    }
  `}
`;

const ProductFilterList = ({ onClick }) => {
  const currentCategory = useSelector(getCurrentCategory);
  const params = useSelector(state => state.product.productFilterParams.filter);
  const productFilter = get(currentCategory, 'filters', null);

  if (!productFilter || productFilter.length === 0) return null;
  const charLimit = 16;

  return (
    <FilterSection>
      {productFilter.map(filter => {
        const { id, title } = filter;

        const paramList = get(params, title, null);
        let filterTitle = `${title}`;

        if (paramList && paramList.length > 0) {
          filterTitle = paramList.join(', ');

          if (filterTitle.length > charLimit) {
            filterTitle = `${filterTitle.substr(0, charLimit)}...`;
          }
        }

        return (
          <div
            className={clsx(
              'h-10 lg:w-max w-1/2 rounded lg:mr-2 mr-0 bg-white flex flex-row p-2.5 justify-between items-center cursor-pointer',
              title === 'Bank Providers' && 'mobile-only',
            )}
            key={id}
            onClick={() => onClick(id)}
          >
            <Text className="mr-2" variant="buttonmd">
              {filterTitle}
            </Text>
            <Filter size={16} />
          </div>
        );
      })}
    </FilterSection>
  );
};

export default ProductFilterList;
